import { render, staticRenderFns } from "./cn.vue?vue&type=template&id=5fcd73c8&scoped=true"
import script from "./cn.vue?vue&type=script&lang=js"
export * from "./cn.vue?vue&type=script&lang=js"
import style0 from "./cn.vue?vue&type=style&index=0&id=5fcd73c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd73c8",
  null
  
)

export default component.exports